import { CalendarModal } from "./calendar.modal";
import { CalendarWeekComponent } from "./calendar-week.component";
import { MonthComponent } from "./month.component";
// import { CalendarComponent } from "./calendar.component";
// import { MonthPickerComponent } from "./month-picker.component";

export const CALENDAR_COMPONENTS = [
  CalendarModal,
  CalendarWeekComponent,
  MonthComponent,
];



// WEBPACK FOOTER //
// ./src/shared/calendar/index.ts